import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    max: { type: Number, default: 15 },
    scale: { type: Number, default: 1.05 }
  }

  connect() {
    this.handleMouseMove = this.onMouseMove.bind(this)
    this.handleMouseLeave = this.onMouseLeave.bind(this)
    this.element.addEventListener('mousemove', this.handleMouseMove)
    this.element.addEventListener('mouseleave', this.handleMouseLeave)
    this.element.style.transformStyle = 'preserve-3d'
    this.element.style.willChange = 'transform'
  }

  disconnect() {
    this.element.removeEventListener('mousemove', this.handleMouseMove)
    this.element.removeEventListener('mouseleave', this.handleMouseLeave)
  }

  onMouseMove(event) {
    const rect = this.element.getBoundingClientRect()
    const x = event.clientX - rect.left
    const y = event.clientY - rect.top
    const centerX = rect.width / 2
    const centerY = rect.height / 2
    const rotateX = ((y - centerY) / centerY) * -this.maxValue
    const rotateY = ((x - centerX) / centerX) * this.maxValue

    this.element.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${this.scaleValue})`
    this.element.style.transition = 'transform 0.1s ease-out'
  }

  onMouseLeave() {
    this.element.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg) scale(1)'
    this.element.style.transition = 'transform 0.4s ease-out'
  }
}
